// src/services/api.ts
import axios from 'axios';

let apiBaseUrl = '';

export const loadConfig = async () => {
  const response = await fetch('/config.json');
  const config = await response.json();
  apiBaseUrl = config.API_BASE_URL;
};

const getApi = () => axios.create({
  baseURL: apiBaseUrl,
});

export const getVuelos = async (params: {
  id_arpt: string;
  id_airline?: string;
  terminal?: string;
  tiempo_antes?: string;
  est_vuelos?: string; 
  movtp?: string;
}) => {
  const api = getApi();
  const response = await api.get('/GetVuelos', { params });
  return response.data;
};

export const getCantidadNOTAMS = async (fecha: string, id_arpt: string) => {
  const api = getApi();
  const response = await api.get('/GetCantidadNOTAMS', { params: { fecha, id_arpt } });
  return response.data;
};

export const getNOTAMS = async (params: {
  id_arpt: string;
  fecha: string;
}) => {
  const api = getApi();
  const response = await api.get('/GetNOTAMS', { params });
  return response.data;
};

export const getAeropuertos = async () => {
  const api = getApi();
  const response = await api.get('/GetAeropuertos');
  return response.data;
};

export const getAerolineas = async (id_arpt: string) => {
  const api = getApi();
  const response = await api.get('/GetAerolineas', { params: { id_arpt } });
  return response.data;
};

export const getTerminales = async (id_arpt: string) => {
  const api = getApi();
  const response = await api.get('/GetTerminales', { params: { id_arpt } });
  return response.data;
};
